import Guesty from 'asset/icons/guesty_logo.svg';
import Hostaway from 'asset/icons/hostaway.svg';
import Hostfully from 'asset/icons/hostfully-logo.svg';
import Lodgify from 'asset/icons/lodgify-logo.svg';
import MaskGuesty from 'asset/icons/mask-guesty.svg';
import MaskHostaway from 'asset/icons/mask-hostaway.svg';
import MaskHostfully from 'asset/icons/mask-hostfully.svg';
import MaskLodgify from 'asset/icons/mask-lodgify.svg';
import MaskOwnerRez from 'asset/icons/mask-ownerrez.svg';
import OwnerRez from 'asset/icons/ownerrez_logo_new.png';

export const integrationItems = [
    {
        key: 'guesty',
        name: 'Guesty',
        logo: Guesty,
        alt: 'Guestly Logo',
        description:
            'The ultimate property management platform for short-term and vacation rentals.',
        maskedLogo: MaskGuesty,
        isActive: false,
    },
    // disabling E-commerce from integration
    // {
    //     key: 'eCommerce',
    //     name: 'E-Commerce',
    //     logo: E_Commerce,
    //     alt: 'E Commerce Logo',
    //     description:
    //         'Use our identity verification on platforms such as Shopify, Magento, Amazon, WooCommerce and many more!',
    //     maskedLogo: MaskEcommerce,
    //     isActive: false,
    // },
    {
        key: 'hostaway',
        name: 'Hostaway',
        logo: Hostaway,
        alt: 'Hostaway Logo',
        description:
            ' Manage unlimited vacation rental channel reservations from check-in to check-out by one platform.',
        maskedLogo: MaskHostaway,
        isActive: false,
    },
    {
        key: 'lodgify',
        name: 'Lodgify',
        logo: Lodgify,
        alt: 'Lodgify Logo',
        description:
            'From website to guest management, Lodgify equips property owners with the tools they need to succeed in the rental industry.',
        maskedLogo: MaskLodgify,
        isActive: false,
    },
    {
        key: 'hostfully',
        name: 'Hostfully',
        logo: Hostfully,
        alt: 'Hostfully Logo',
        description:
            'Hostfully empowers property managers to manage their businesses at scale with an affordable, easy-to-use platform solution',
        maskedLogo: MaskHostfully,
        isActive: false,
    },
    {
        key: 'ownerrez',
        name: 'OwnerRez',
        logo: OwnerRez,
        alt: 'OwnerRez Logo',
        description:
            'OwnerRez simplifies vacation rental management with tools for channel management, CRM, accounting, and automation.',
        maskedLogo: MaskOwnerRez,
        isActive: false,
    },
];

export const getGuestyPassCriteria = (workflow) => {
    const idVerification = workflow?.id_verifications;

    const govtId = idVerification?.find((item) => item.verification_type === 'govt_id');
    const isGovtEnabled = govtId?.enabled;
    const isSelfieEnabled = govtId?.metadata?.livenessCheck?.enabled ?? false;

    const isKbaEnabled = idVerification?.find((item) => item.verification_type === 'kba')?.enabled;
    const isBankEnabled = idVerification?.find(
        (item) => item.verification_type === 'bank'
    )?.enabled;
    const isSevenCheckEnabled = workflow?.additional_checks?.find(
        (item) => item.check_type === 'seven_year_criminal_report'
    )?.enabled;

    const isAuthDbCheckEnabled = workflow?.additional_checks?.find(
        (item) => item.check_type === 'authoritative_db'
    )?.enabled;

    return [
        {
            value: 'valid_and_verified',
            label: 'ID: Valid & Verified',
            disabled: !(isGovtEnabled && isAuthDbCheckEnabled),
        },
        {
            value: 'valid_and_not_verified',
            label: 'ID: Valid & Not Verified',
            disabled: !isGovtEnabled,
        },
        {
            value: 'valid_and_live_match_fail',
            label: 'ID: Valid & Live Match Fail',
            disabled: !(isGovtEnabled && isSelfieEnabled),
        },
        { value: 'valid_and_not_us_id', label: 'ID: Valid & Not US ID', disabled: !isGovtEnabled },
        { value: 'kba_verified', label: 'KBA: Verified', disabled: !isKbaEnabled },
        {
            value: 'fao_verified',
            label: 'Financial Account Ownership: Verified',
            disabled: !isBankEnabled,
        },
        {
            value: 'clear',
            label: '7 year criminal Activity check: Clear',
            disabled: !isSevenCheckEnabled,
        },
        {
            value: 'requires_review',
            label: '7 year criminal Activity check: Requires Review',
            disabled: !isSevenCheckEnabled,
        },
        {
            value: 'insufficient_data',
            label: '7 year criminal Activity check: Insufficient Data',
            disabled: !isSevenCheckEnabled,
        },
    ];
};

export const passCriteriaOptionsInfo = {
    valid_and_verified:
        "The Guest's ID has to be valid, and verifiable via authoritative databases.",
    valid_and_not_verified:
        "The Guest's ID has to be valid, but it doesn't have to be verified via authoritative databases.",
    valid_and_live_match_fail:
        "Guest's selfie doesn't match the photo on the ID, but the ID has to be valid.",
    valid_and_not_us_id: 'The Guest has to have a valid International ID card.',
    kba_verified: "The Guest's Identity has to pass KBA.",
    fao_verified: 'The Guest has to prove ownership of a financial account.',
    clear: "The Guest's 7 Year Criminal Report has to have returned no records",
    requires_review: "The Guest's 7 Year Criminal Report has to contain some records.",
    insufficient_data:
        "Insufficient data will prevent the generation of the Guest's 7 Year Criminal Report.",
};

export const GUESTY_SETTING_NAMES = {
    API: 'API Key',
    API_V2: 'ApiKeyV2',
    ACTIVE: 'Active',
    PASS_CRITERIA: 'passCriteria',
    ENABLED_ADDITIONAL_CHECKS: 'enabledAdditionalChecks',
    DISABLED_BOOKING_CHANNELS: 'disabled_booking_channels',
};

export const HOSTAWAY_SETTING_NAMES = {
    ACCOUNT_ID: 'AccountId',
    API_KEY: 'ApiKey',
    ACTIVE: 'Active',
    DISABLED_BOOKING_CHANNELS: 'disabled_booking_channels',
};

export const LODGIFY_SETTING_NAMES = {
    API_KEY: 'API Key',
    ACTIVE: 'Active',
};

export const ENABLED_ADDITIONAL_CHECKS = {
    VALUES: { sevenYearCheck: 'sevenYearCriminalStatus', verifyId: 'idStatus' },
};

export const redirectingUrls = {
    GUESTY_AUTHENTICATE_MARKETPLACE: 'https://app.guesty.com/integrations/partners/authenticate',
    HOSTAWAY_AUTHENTICATE_MARKETPLACE:
        'https://dashboard.hostaway.com/v3/marketplace/authenticating-com',
    LODGIFY_AUTHENTICATE_MARKETPLACE: 'https://app.lodgify.com/marketplace/authenticate',
    HOSTFULLY_AUTHENTICATE_MARKETPLACE: 'https://www.hostfully.com/integrations/authenticate',
};

export const toasterMessage = {
    TOKEN_ACTIVATION_SUCCESS: 'Token activation was successful.',
    TOKEN_ACTIVATION_FAILED: 'Token activation failed, please try again.',
    TOKEN_DEACTIVATION_SUCCESS: 'You have deactivated this integration.',
    TOKEN_DEACTIVATION_FAILED: 'Token deactivation failed, please try again.',
    BOOKING_CHANNELS_SAVE_SUCCESS: 'Booking channel preferences saved.',
    BOOKING_CHANNELS_SAVE_FAILED: 'Failed to save booking channel preferences, please try again.',
    BOOKING_CHANNELS_FETCH_FAILED: 'Failed to load booking channels, please try again.',
};

export const VERIFICATIONS_VALUES = {
    GOVT_ID: 'govt_id',
    KBA: 'kba',
    FAO: 'bank',
    AUTH_DB: 'authoritative_db',
    CRIMINAL_CHECK: 'has_criminal_record',
    SEVEN_YEAR_CRIMINAL_CHECK: 'seven_year_criminal_report',
    EDUCATION: 'education',
    EMPLOYMENT: 'employment',
    PROFESSIONAL_LICENSE: 'professional_license',
    QUICK_VERIFY: 'quick_verify',
    TWO_FA: '2fa',
    RISK_SCORE: 'risk_score',
    SOC: 'sex_offender',
    GWC: 'global_watchlist',
};

export const VERIFICATION_LABEL = {
    [VERIFICATIONS_VALUES.GOVT_ID]: 'Government ID',
    [VERIFICATIONS_VALUES.KBA]: 'KBA',
    [VERIFICATIONS_VALUES.FAO]: 'Financial Account Ownership',
    [VERIFICATIONS_VALUES.AUTH_DB]: 'Authoritative DB Check',
    [VERIFICATIONS_VALUES.CRIMINAL_CHECK]: 'Criminal Check',
    [VERIFICATIONS_VALUES.SEVEN_YEAR_CRIMINAL_CHECK]: '7 Year Criminal Check',
    [VERIFICATIONS_VALUES.EDUCATION]: 'Education',
    [VERIFICATIONS_VALUES.EMPLOYMENT]: 'Employment',
    [VERIFICATIONS_VALUES.PROFESSIONAL_LICENSE]: 'Professional License',
    [VERIFICATIONS_VALUES.QUICK_VERIFY]: 'Quick Verify',
    [VERIFICATIONS_VALUES.TWO_FA]: '2FA',
    [VERIFICATIONS_VALUES.RISK_SCORE]: 'Risk Assessment',
    [VERIFICATIONS_VALUES.SOC]: 'Sex Offender Check',
    [VERIFICATIONS_VALUES.GWC]: 'Global Watchlist Check',
};

export const passCriteria = [
    'valid_and_verified',
    'valid_and_not_verified',
    'valid_and_live_match_fail',
    'valid_and_not_us_id',
    'kba_verified',
    'fao_verified',
    'clear',
    'requires_review',
    'insufficient_data',
];
export const GROUP_NODE_WIDTH = 342;

export const rootNode = {
    id: 'root',
    position: {
        x: 0,
        y: 0,
    },
    type: 'root',
    data: {
        label: 'Verification Passed if',
    },
    measured: {
        width: GROUP_NODE_WIDTH,
        height: 141,
    },
};

export const parentNodeMapper = {
    document_root: {
        label: 'ID Document is',
        type: 'document',
        children: [
            'valid_and_verified',
            'valid_and_not_verified',
            'valid_and_live_match_fail',
            'valid_and_not_us_id',
        ],
        measured: {
            width: 278,
        },
    },
    kba_root: {
        label: 'KBA is',
        type: 'kba',
        children: ['kba_verified'],
        measured: {
            width: 278,
        },
    },
    fao_root: {
        label: 'Financial Account Ownership is',
        type: 'fao',
        children: ['fao_verified'],
        measured: {
            width: 430,
        },
    },
    criminal_root: {
        label: '7-year Criminal Activity Check',
        type: 'criminal',
        children: ['clear', 'requires_review', 'insufficient_data'],
        measured: {
            width: 418,
        },
    },
};

export const childNodeMapper = {
    valid_and_verified: {
        data: {
            label: 'Valid and Verified',
            type: 'verified',
        },
        measured: {
            width: 244,
        },
    },
    valid_and_not_verified: {
        data: {
            label: 'Valid and Not Verified',
            type: 'verified',
        },
        measured: {
            width: 275,
        },
    },
    valid_and_live_match_fail: {
        data: {
            label: 'Valid and Live Match Fail',
            type: 'verified',
        },
        measured: {
            width: 298,
        },
    },
    valid_and_not_us_id: {
        data: {
            label: 'Valid and Not US',
            type: 'verified',
        },
        measured: {
            width: 238,
        },
    },
    kba_verified: {
        data: {
            label: 'Verified',
            type: 'verified',
        },
        measured: {
            width: 171,
        },
    },
    fao_verified: {
        data: {
            label: 'Verified',
            type: 'verified',
        },
        measured: {
            width: 171,
        },
    },
    clear: {
        data: {
            label: 'Clear',
            type: 'verified',
        },
        measured: {
            width: 151,
        },
    },
    requires_review: {
        data: {
            label: 'Requires Attention',
            type: 'warning',
        },
        measured: {
            width: 255,
        },
    },
    insufficient_data: {
        data: {
            label: 'Insufficient Data',
            type: 'noData',
        },
        measured: {
            width: 239,
        },
    },
};

export const PROPERTY_RENTALS = {
    GUESTY: 'guesty',
    HOSTAWAY: 'hostaway',
    LODGIFY: 'lodgify',
    HOSTFULLY: 'hostfully',
    OWNERREZ: 'ownerrez',
};

export const HOSTFULLY_CONNECT_STATUS = {
    SUCCESSFUL: 'SUCCESSFUL',
    DECLINED: 'DECLINED',
    INCORRECT_REQUEST: 'INCORRECT_REQUEST',
};

export const LISTINGS_FILTER_TAGS = [
    { key: 'enabled', label: 'Enabled Listings' },
    { key: 'disabled', label: 'Disabled Listings' },
];

export const SYNC_LISTINGS_STATUS = {
    COMPLETED: 'completed',
    FAILED: 'failed',
    IN_PROGRESS: 'in-progress',
};

export const HEADER_MENU_LABELS = {
    MANAGE_BOOKING_CHANNELS: 'Manage Booking Channels',
    MANAGE_LISTINGS: 'Manage Listings',
    SETUP_GUIDE: 'Setup Guide',
};

export const BOOKING_CHANNELS_COPY = {
    TITLE: 'Manage Booking Channels',
    SUB_TITLE:
        'By default, users and verification links will be created for all selected booking channels, uncheck any booking channel you wish to skip',
    SEARCH_PLACEHOLDER: 'Search by booking channel name',
    SELECT_ALL: 'Select all',
    CLEAR_ALL: 'Clear all',
    SAVE: 'Save Changes',
    CANCEL: 'Cancel',
    // `${count} of ${total} booking channels selected` — shown when not searching
    countSelected: (count, total) => `${count} of ${total} booking channels selected`,
    // `${shown} of ${total} booking channels shown` — shown while a search term is active
    countShown: (shown, total) => `${shown} of ${total} booking channels shown`,
};

export const DISCARD_DIALOG_COPY = {
    TITLE: 'Discard your changes?',
    DESCRIPTION:
        "Your changes to booking channels haven't been saved. If you leave now they'll be lost.",
    SECONDARY_BTN: 'Keep editing',
    PRIMARY_BTN: 'Discard changes',
};

export const BOOKING_CHANNELS_LOADING_KEYS = {
    SAVE: 'saveBookingChannels',
};

// ROW_COUNT is a filler figure — enough placeholder rows to cover the drawer at
// desktop height without pretending to match the real channel count.
export const BOOKING_CHANNELS_SKELETON = {
    ROW_COUNT: 18,
    commonSkeletonProps: {
        variant: 'rectangular',
        animation: 'wave',
    },
};
